import { FC } from "react";
import { useTranslation } from "react-i18next";
import { getInstagramFollowersDefinitionInfo } from "../OrganicMediaDefinitions";
import InstagramRankedFollowersPanel, {
  type InstagramFollowersGeoRow,
} from "./InstagramRankedFollowersPanel";
import "../../../styles/InstagramFollowersReport/InstagramFollowersByCountry.scss";

type InstagramFollowersByCountryProps = {
  rows: InstagramFollowersGeoRow[];
  value: number;
  max: number;
  onChange: (_value: number) => void;
};

const InstagramFollowersByCountry: FC<InstagramFollowersByCountryProps> = ({
  rows,
  value,
  max,
  onChange,
}) => {
  const { t } = useTranslation();

  return (
    <InstagramRankedFollowersPanel
      title={t("organicMedia.followers.totalByCountry")}
      tooltipInfo={getInstagramFollowersDefinitionInfo("Total Followers by Country", undefined, t)}
      topLabel={t("organicMedia.followers.topCountryLabel")}
      rows={rows}
      value={value}
      disabled={rows.length === 0}
      onChange={next => {
        const n = Math.max(1, Math.min(max, next));
        onChange(n);
      }}
      formulaTitle={t("organicMedia.common.formula")}
      emptyLabel={t("webAnalytics.noData")}
    />
  );
};

export default InstagramFollowersByCountry;
